import axios from "axios";
import {carmelConstAPI, carmelConstAPIMethods, formsConstants, generalConstants} from '../../constants';
import {generalService} from "../general/services";
import {store} from '../index';

export const userService = {
    login,
    facebookLogin,
    logout,
    register,
    passwordRecovery,
    uploadImage,
    loadBasicUserInformation,
    updateUserInfo,
    subscribe,
    getTripList,
    getFutureTripList,
    getPastTripList,
    getCarCashList,
    updatePassword,
    Cust
};


function login() {
    const state = store.getState();
    const {CoreCredentials} = state.authentication;
    const loginForm = state.forms[formsConstants.LOGIN_FORM];
    const registerForm = state.forms[formsConstants.REGISTER_FORM];
    let username = '';
    let password = '';
    if (loginForm) {
        username = loginForm[formsConstants.LOGIN_USERNAME];
        password = loginForm[formsConstants.LOGIN_PASSWORD];
    } else {
        username = registerForm[formsConstants.REGISTER_EMAIL];
        password = registerForm[formsConstants.REGISTER_PASSWORD];
    }

    return generalService.requestSender(
        carmelConstAPIMethods.CUST_LOGIN,
        {
            Credentials: {
                ...CoreCredentials,
                accessToken: generalConstants.CARMEL_API_KEY,
                custAuthType: carmelConstAPI.authTypeCarmel,
                custLoginId: username,
                custPassword: password,
            }
        }
    );
}

function facebookLogin() {
    const state = store.getState();
    const {Cust} = state.user;
    const registerForm = state.forms[formsConstants.REGISTER_FORM];
    //take missing fields from form is arguments in the cust were missing
    if (registerForm && registerForm[formsConstants.REGISTER_PHONE] && registerForm[formsConstants.REGISTER_COUNTRY] && !Cust.phone) {
        Cust.phone = {
            countryCode: registerForm[formsConstants.REGISTER_COUNTRY].id,
            number: registerForm[formsConstants.REGISTER_PHONE],
        }
    }
    if (registerForm && registerForm[formsConstants.REGISTER_EMAIL] && !Cust.emailAddr) {
        Cust.emailAddr = registerForm[formsConstants.REGISTER_EMAIL];
    }
    // const {selectedOptionID} = userActionOptions;
    return generalService.requestSender(
        carmelConstAPIMethods.FACEBOOK_LOGIN,
        {
            'Credentials': generalService.getCarmelCredentials(),
            "FacebookLogin": {
                "cust": Cust,
            }
        });
}

function logout() {
    // Remove the app Credential state from local storage to avoid auto-login
    localStorage.removeItem('Credentials');
}

function register() {
    const state = store.getState();
    const {CoreCredentials} = state.authentication;
    if (!state.forms[formsConstants.REGISTER_FORM]) {
        return;
    }

    const registerForm = state.forms[formsConstants.REGISTER_FORM];
    const emailAddr = registerForm[formsConstants.REGISTER_EMAIL];
    const firstName = registerForm[formsConstants.REGISTER_FNAME];
    const lastName = registerForm[formsConstants.REGISTER_LNAME];
    const password = registerForm[formsConstants.REGISTER_PASSWORD];
    const passwordCon = registerForm[formsConstants.REGISTER_PASSWORD_CON];
    const country = registerForm[formsConstants.REGISTER_COUNTRY];
    const countryIce = registerForm[formsConstants.REGISTER_COUNTRY_ICE];
    const phoneIce = registerForm[formsConstants.REGISTER_PHONE_ICE];
    const number = registerForm[formsConstants.REGISTER_PHONE];
    // const pictureUrl = state.temp.services.imageAsFormData;

    return generalService.requestSender(
        carmelConstAPIMethods.CUST_REGISTER,
        {
            Credentials: {
                ...CoreCredentials,
                accessToken: generalConstants.CARMEL_API_KEY,
                custAuthType: carmelConstAPI.authTypeCarmel
            },
            Cust: {
                emailAddr,
                firstName,
                lastName,
                phone: {
                    countryCode: country.phoneCode,
                    number,
                },
                phoneIce: {
                    countryCode: countryIce ? countryIce.phoneCode : '',
                    number: phoneIce,
                }
            },
            CustPassword: {
                newPassword1: password,
                newPassword2: passwordCon
            },

        }
    );
}

function updateUserInfo(userUpdatedFields) {
    const state = store.getState();
    const previousUser = state.user.Cust;

    const Cust = {
        ...previousUser,
        ...userUpdatedFields,
    };
    return generalService.requestSender(
        carmelConstAPIMethods.CUST_UPDATE,
        {
            'Credentials': generalService.getCarmelCredentials(),
            Cust
        });
}

function updatePassword(CustPassword) {
    return generalService.requestSender(
        'CustPassword',
        {
            'Credentials': generalService.getCarmelCredentials(),
            CustPassword
        }
    );
}

function passwordRecovery(custLoginId) {
    const CustPassword = {
        resetPassword: true,
        custLoginId
    };

    return generalService.requestSender(
        'CustPassword',
        {
            Credentials: {
                ...generalService.getCarmelCredentials()
            },
            CustPassword
        }
    );
}

function uploadImage(imageFile) {
    const requestOptions = {
        method: 'post',
        url: generalConstants.imageUpload,
        headers: {
            'Credentials': JSON.stringify(generalService.getCarmelCredentials()),
            'Content-Type': 'multipart/form-data'
        },
        data: imageFile,
    };

    return axios(requestOptions)
        .then(generalService.handleAxiosResponse)
        .then(response => {
            console.log("imageUpload: response", response);
            return response;
        });
}


function loadBasicUserInformation() {
    const Credentials = generalService.getCarmelCredentials();
    // build an array of all requests need to make
    return generalService.multipleCallsSender(
        {}, [
            {
                method: carmelConstAPIMethods.CUST_FOP_LIST,
                params: {Credentials}
            },
            {
                method: carmelConstAPIMethods.CUST_ADDRESS_LIST,
                params: {Credentials}
            },
            {
                method: carmelConstAPIMethods.CUST_RECENT_TRIP_LIST,
                params: {Credentials}
            },
            {
                method: carmelConstAPIMethods.REWARD_PROGRAM_LIST,
                params: {Credentials}
            },
            {
                method: carmelConstAPIMethods.REFERRAL_CODE_SUBMIT,
                params: {
                    Credentials,
                    "AppReferral": {
                        "sendCode": true,
                    }
                }
            }
        ],
        'loadBasicUserInformation'
    );
}

function getTripList() {
    const Credentials = generalService.getCarmelCredentials();
    return generalService.multipleCallsSender(
        {}, [
            {
                method: carmelConstAPIMethods.TRIP_LIST,
                params: {
                    Credentials,
                    tripListType: "Future"
                }
            },
            {
                method: carmelConstAPIMethods.TRIP_LIST,
                params: {
                    Credentials,
                    tripListType: "History"
                }
            },
            {
                method: carmelConstAPIMethods.CUST_RECENT_TRIP_LIST,
                params: {
                    Credentials
                }
            }
        ],
        'getTripList'
    );
}

function getFutureTripList() {
    return generalService.requestSender(
        carmelConstAPIMethods.TRIP_LIST,
        {
            "preview": false,
            "dtFrom": "",
            "dtTo": "",
            "tripListType": "Future",
            "Credentials": generalService.getCarmelCredentials()
        }
    )
}

function getCarCashList(update, id) {
    return generalService.requestSender(
        carmelConstAPIMethods.CUST_CAR_CASH_LIST,
        {
            "CustCarCash": {
                "requestedMarket": id,
                "requestCarCash": update,
            },
            "Credentials": generalService.getCarmelCredentials()
        }
    )
}

function getPastTripList() {
    return generalService.requestSender(
        carmelConstAPIMethods.TRIP_LIST,
        {
            "preview": false,
            "dtFrom": "",
            "dtTo": "",
            "tripListType": "History",
            "Credentials": generalService.getCarmelCredentials()
        }
    )
}

function subscribe(email) {
    const requestOptions = {
        method: 'POST',
        body: {
            'email': email
        }
    };
    return axios(generalConstants.subscribeEndPoint, requestOptions)
        .then(generalService.handleAxiosResponse)
        .then(response => {
            return response;
        });
}

function Cust() {
    return generalService.requestSender(
        carmelConstAPIMethods.CUST,
        {
            Credentials: {
                ...generalService.getCarmelCredentials(),
            }
        }
    );
}